import type { IComponentController } from "angular";
import { PhoneNumberType } from "../../../Models";

export class PhoneNumberTypeComponentController implements IComponentController {
    public ngModel: string;

    public isPhoneNumberTypeCustom() {
        return (PhoneNumberType as any)[this.ngModel] === undefined;
    }
}
